import React from 'react';

const PhoneIconHeader = ({
  size = 20,
  fill = '#4F4C4D',
}: {
  size?: number | string;
  fill?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.221 17.0352C14.5725 17.0406 12.9537 16.6608 11.3645 15.8958C9.77528 15.1309 8.35515 14.1255 7.10408 12.8798C5.85301 11.6341 4.845 10.2166 4.08005 8.6274C3.3151 7.0382 2.93262 5.41935 2.93262 3.77085C2.93262 3.64585 2.93742 3.50349 2.94703 3.34377C2.95664 3.18405 2.97534 3.04169 3.00312 2.91669H7.31076L8.09122 6.70352L5.78033 8.97596C6.3829 10.0379 7.1329 11.0198 8.03035 11.9215C8.92778 12.8232 9.94541 13.6026 11.0832 14.2596L13.3461 11.8943L17.0672 12.6939V16.9647C16.9475 16.9978 16.8065 17.0179 16.6441 17.0248C16.4817 17.0318 16.3407 17.0352 16.221 17.0352ZM5.13933 7.70996L6.63612 6.28527L6.21785 4.25H4.30758C4.32894 4.84296 4.41334 5.42924 4.56078 6.00883C4.70823 6.58843 4.90108 7.15547 5.13933 7.70996ZM12.3364 14.8846C12.8567 15.0983 13.4168 15.2756 14.0167 15.4167C14.6166 15.5577 15.189 15.6416 15.7339 15.6683V13.758L13.8012 13.3622L12.3364 14.8846Z"
        fill={fill}
      />
    </svg>
  );
};

export default PhoneIconHeader;
